<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addNews">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        ref="dragTable"
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        :row-selection="{ selectedRowKeys: table.sectionData,onChange: handleSelectionChange }"
        row-key="id"
        @selection-change="handleSelectionChange"
        @change="handleTableChange"
        :columns="table.columns"
        style="width: 100%">
        <span slot="coverPath" slot-scope="text, record">
           <a-avatar :size="80" shape="square" :src="record.coverPath"/>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="editNews(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
          <a-button type="link" @click="deleteNews(record.id)">{{ $t('DELETE') || '删除' }}</a-button>
        </span>
        <template slot="sort">
          <a-icon type="drag" style="font-size: 25px;"/>
        </template>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      :title="$t('BRAND_NEWS_EDIT')||'操作'"
      width="50%"
      mask-closeable="false"
      v-model="form.visible">
      <website-news-edit
        v-if="form.visible"
        :news-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-news-edit>
    </a-modal>
  </a-card>
</template>

<script>
import { _deleteNews, _queryWebsiteNews, _updateNewsSort } from '@/api/websiteNewsApi';
import WebsiteNewsEdit from './WebsiteNewsEdit.vue';
import Sortable from 'sortablejs';
async function getNewsList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryWebsiteNews({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addNews() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editNews(newsId) {
  this.$router.push(`/website-news/${newsId}`);
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getNewsList();
}

const columns = [
  {
    title: '类型',
    dataIndex: 'articleType'
  },
  {
    title: '主题',
    dataIndex: 'title',
    scopedSlots: { customRender: 'title' },
  },
  // {
  //   title: '发表时间',
  //   dataIndex: 'postAt',
  // },
  {
    title: '封面图片',
    dataIndex: 'coverPath',
    scopedSlots: { customRender: 'coverPath' },
  },
  {
    title: '拖拽排序',
    align: 'center',
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
];

async function deleteNews(newsId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteNews(newsId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getNewsList();
    },
  });
}
async function updateSortList(oldIndex, newIndex) {
  const idStr = this.table.data.map(x => x.id).join(',')
  const sortStr = this.table.data.map(x => x.sort).join(',')
  const result = await _updateNewsSort({
    idStr,
    sortStr,
    oldIndex,
    newIndex
  })
  if (result) {
    this.$message.success('移动排序成功')
    await this.getNewsList()
  }
}
function initSortable() {
  const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
  const dragTable = Sortable.create(el, {
    handle: 'td:nth-child(5)',
    animation: 150,
    onUpdate: (e) => {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      if (oldIndex === newIndex) {
        return
      }
      this.updateSortList(oldIndex, newIndex)
    },
  })
}

function handleSelectionChange(selectedRowKeys) {
  this.table.sectionData = selectedRowKeys;
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  if (sorter.field) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    };
  }
  this.getNewsList();
}

export default {
  name: 'WebsiteNewsList',
  components: {
    WebsiteNewsEdit,
  },
  data() {
    return {
      brand: {
        data: [],
      },
      searchForm: {
        data: {
          brandId: '',
          title: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns,
        sectionData: [],
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getNewsList,
    deleteNews,
    handleSelectionChange,
    handleTableChange,
    updateSortList,
    initSortable,
    editNews,
    addNews,
    closeForm,
  },
  mounted() {
    this.initSortable();
  },
  async created() {
    await this.getNewsList();
  },
};
</script>

<style scoped>

</style>
